import type {MobileAlgoPlugin, MobileAlgoPluginInitializationArgs, PluginHeuristicsRegistry} from '../../types'
import * as flush from './flush'
import * as adaptive from './adaptive'
import {AlgorithmModes} from '../../enums'
import {generatePluginHandlerPerMode} from '../common'

export const createPlugin = ({stages, readOnlyExtensionAPI}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const orderRealStructureRunners = {
        [AlgorithmModes.Adaptive]: adaptive.createOrderRealStructure(readOnlyExtensionAPI),
        [AlgorithmModes.Flush]: flush.orderRealStructure
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.GROUPING_ORDER, flush.createOrderVirtualStructure(readOnlyExtensionAPI))
        registry.register(stages.STRUCTURE_ORDER, generatePluginHandlerPerMode(orderRealStructureRunners))
    }

    return {register, name: 'order', dependencies: []}
}
